define('views/components/installment_options/installment_options',['require','backbone','select2','text!templates/components/installment_options/installment_options.html'],function(require){

    var Backbone = require('backbone');
    require('select2');

    var temp = require("text!templates/components/installment_options/installment_options.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'installment-options-item',

        initialize: function(options) {
            // this.installmentOptions = [{
            //     installment: 1,
            //     cost_percentage: 0
            // }];
            this.installmentOptions = null;
            this.selectedInstallment = 1;
            this.pricingDetails = {
                price: 0,
                currency: 'USD'
            };
            this.hasInstallment = false;
        },

        ui: function() {
            return {
                installmentsSelect: '#installments'
            };
        },

        events: {
            'change @ui.installmentsSelect': 'installmentsSelectChanged'
        },

        templateHelpers: function(){
            return {
                hasInstallment: this.hasInstallment,
                installmentOptions: this.installmentOptions,
                selectedInstallment: this.selectedInstallment,
                pricingDetails: this.pricingDetails
            };
        },

        onBeforeRender: function() {
            if (this.installmentOptions && this.installmentOptions.indexOf(this.selectedInstallment) === -1) {
                this.selectedInstallment = 1;
            }
        },

        onRender: function() {
            this.ui.installmentsSelect.select2();
        },

        installmentsSelectChanged: function () {
            this.selectedInstallment = this.ui.installmentsSelect.val();
        }
    });
});
